import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import Header from "../../layouts/header/Header";
import SavedProductsMain from "../../layouts/main/product/SavedProductsMain";

const SavedProducts = () => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t("CART.SAVED_FOR_LATER")} | SnusCo</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <SavedProductsMain />
      <Footer />
    </div>
  );
};

export default SavedProducts;
